import React, { useEffect, useState } from 'react';// useState
import Paper from '@material-ui/core/Paper';
import { Grid, TextField, Typography } from '@material-ui/core';
import { getTheme } from 'theme';
import AppLoader from 'components/basic/AppLoader';
import ItemsDropdownButton from '../../ItemsDropdownButton';
import { useGetThematicGroups } from '../../../../hooks/thematic-group-hooks';

const ProductDetails = (props) => {
  const { thematicPackage, productDetails, setProductDetailsProperty } = props;

  const { thematicGroupsLoading } = useGetThematicGroups();

  const [ taxerror, setTaxError ] = useState(false);
  const [ werror, setWError ] = useState(false);
  const [ rerror, setRerror ] = useState(false);

  const numRegex = /^[+-]?\d+(\.\d+)?$/;

  const re = /(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)$/;

  useEffect(() => {
    console.log('taxerror:', taxerror);
  }, [ taxerror ]);

  if (thematicGroupsLoading) { return <AppLoader />; }

  return (
    <>
      <Paper style={ { padding: getTheme().spacing(4), margin: getTheme().spacing(3) } }>

        <Typography variant='h5'>Add Product Details</Typography>
        <br />
        <Typography variant='body1'>
          Name:
          {' '}
          {thematicPackage?.name}
        </Typography>
        <Typography variant='body1'>
          Description:
          {' '}
          {thematicPackage?.description}
        </Typography>
        <Grid container>
          <Grid item xs={ 6 } spacing={ 3 }>
            <TextField
              value={ productDetails?.measurement_unit }
              required
              onChange={ (e) => {
                setProductDetailsProperty('measurement_unit', e.target.value);
              } }
              style={ { width: 300 } }
              label='Measurement Unit'
            />
            <TextField
              value={ productDetails.tax }
              required
              onChange={ (e) => {
                setTaxError(!re.test(e.target.value));
                setProductDetailsProperty('tax', e.target.value);
              } }
              style={ { width: 300 } }
              label='Taxation'
              helperText={ taxerror ? 'The field requires only numbers in range 0-100' : '' }
              error={ taxerror }
            />
            <TextField
              value={ productDetails.accounting_category }
              required
              onChange={ (e) => {
                setProductDetailsProperty('accounting_category', e.target.value);
              } }
              style={ { width: 300 } }
              label='Accounting Category'
            />
          </Grid>
          <br />
          <Grid item xs spacing={ 3 }>
            <TextField
              value={ productDetails.barcode }
              required
              onChange={ (e) => {
                setProductDetailsProperty('barcode', e.target.value);
              } }
              style={ { width: 300 } }
              label='Barcode'
            />
            <TextField
              value={ productDetails.business_unit }
              required
              onChange={ (e) => {
                setProductDetailsProperty('business_unit', e.target.value);
              } }
              style={ { width: 300 } }
              label='Business Unit'
            />
            <TextField
              value={ productDetails.wholesale_price }
              required
              onChange={ (e) => {
                setWError(!numRegex.test(e.target.value));
                setProductDetailsProperty('wholesale_price', e.target.value);
              } }
              style={ { width: 300 } }
              label='Wholesale Price'
              helperText={ werror ? 'This field requires only numbers' : '' }
              error={ werror }
            />
            <TextField
              value={ productDetails.retail_price }
              required
              onChange={ (e) => {
                setRerror(!numRegex.test(e.target.value));
                setProductDetailsProperty('retail_price', e.target.value);
              } }
              style={ { width: 300 } }
              label='Retail Price'
              helperText={ rerror ? 'This field requires only numbers' : '' }
              error={ rerror }
            />
          </Grid>
          <Grid item xs={ 4 } spacing={ 3 }>
            <ItemsDropdownButton
              onChange={ (v) => {
                setProductDetailsProperty('thematicGroup_id', v);
              } }
              title='Thematic Group'
              collection='thematicgroups'
              defaultvalue={ productDetails.thematicGroup_id }
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};
export default ProductDetails;
/*
         <p>{JSON.stringify(thematicPackage)}</p>
            <p>{JSON.stringify(productDetails)}</p>
            <p>{JSON.stringify(productDetails.thematicGroup_id)}</p>
*/
